import { z } from '@/utils/zod'

export const BaseChannelPermissionMembersSchema = z.object({
    read: z.boolean(),
    edit: z.boolean(),
    remove: z.boolean(),
})

export type BaseChannelPermissionMembers = z.infer<typeof BaseChannelPermissionMembersSchema>

export const BaseChannelPermissionMessageSchema = z.object({
    insert: z.boolean(),
    edit: z.boolean(),
    remove: z.boolean(),
    react: z.boolean(),
    pin: z.boolean(),
    quote: z.boolean(),
})

export type BaseChannelPermissionMessage = z.infer<typeof BaseChannelPermissionMessageSchema>

export const BaseChannelPermissionSurveySchema = z.object({
    insert: z.boolean(),
    results: z.boolean(),
    vote: z.boolean(),
    queryResults: z.boolean(),
    hiddenResults: z.boolean(),
})

export type BaseChannelPermissionSurvey = z.infer<typeof BaseChannelPermissionSurveySchema>
